"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PermissionContext = react_1.default.createContext({
    allowView: true,
    allowEdit: true,
});
exports.default = PermissionContext;
